module.exports = __webpack_public_path__ + "static/media/De_Wulverhorst.1bd27d23.jpg";